import { Layout, Spin } from "antd";
import {
  cloneElement,
  FC,
  isValidElement,
  PropsWithChildren,
  ReactElement,
} from "react";

import styles from "./index.less";

import { PageConfigContext, PageConfigContextType } from "./PageConfigProvider";
import FlowEdit from "./components/FlowEdit";
import { useFlow } from "./components/FlowEdit/useFlow";
import { LoadingOutlined } from "@ant-design/icons";

type FlowEditPageProps = PageConfigContextType;

const Header: FC<PropsWithChildren> = ({ children }) => {
  if (!children) return children;

  if (!isValidElement(children)) return children;

  return cloneElement(
    children as ReactElement<{
      useFlow: any;
    }>,
    {
      useFlow,
    }
  );
};

export default function FlowEditPage(props: FlowEditPageProps) {
  return (
    <PageConfigContext.Provider value={props}>
      <Layout className={styles.page}>
        <Spin
          fullscreen
          spinning={props.loading}
          indicator={<LoadingOutlined style={{ fontSize: 48 }} />}
          size="large"
        ></Spin>
        <FlowEdit
          defaultValue={props.defaultValue}
          key={props.defaultValue?.id}
          header={<Header>{props.header}</Header>}
          mode={props.mode}
        />
      </Layout>
    </PageConfigContext.Provider>
  );
}
